export default "__VITE_ASSET__Eo2kFNrq__"